import { useMemo } from 'react';
import { BackgroundProcess } from 'src/data-capture/hooks/file-uploads/types';
import { useProcessingDataExportDocument } from './useProcessingDataExportDocument';

type DataExport = {
  id: string;
  clientId?: string;
  familyId?: string;
  fileId?: number;
  fileName?: string;
  createdAt: string;
  isGenerated: true;
  backgroundProcess?: BackgroundProcess;
  templateId?: string;
  documentHistoryId?: string;
  configDisplayName?: string;
};

type Props = {
  clientId?: string;
};

export const useDataExports = ({ clientId }: Props = {}) => {
  const { items, isLoading, isError, error, refetch } = useProcessingDataExportDocument<
    Omit<DataExport, 'isGenerated'>
  >({
    clientId,
    resource: 'data-exports',
  });

  const dataExports = useMemo(
    () => items.map(dataExport => ({ ...dataExport, isGenerated: true })),
    [items],
  );

  return {
    dataExports,
    isLoading,
    isError,
    error,
    refetch,
  };
};
